import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import DestinationsSection from './components/DestinationsSection';
import VehiclesSection from './components/VehiclesSection';
import ReservationModule from './components/ReservationModule';
import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import { useSEO, generateOrganizationSchema, generateServiceSchema } from '../../utils/seo';

export default function HomePage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

  useSEO({
    title: 'Voyage Elite | Transport Privé Premium Genève Lyon Stations Ski Alpes',
    description: 'Service de transport privé premium entre Genève, Lyon et les stations de ski alpines. Excellence, ponctualité et confort depuis 2018. Mercedes Classe E et Van luxe, chauffeur professionnel, service 24/7.',
    keywords: 'transport privé ski Alpes, transfert aéroport Genève station ski, VTC Lyon Courchevel, chauffeur privé Chamonix, transport premium Méribel Val d\'Isère',
    canonical: '/',
    ogTitle: 'Voyage Elite - Transport Privé Premium vers les Stations de Ski Alpines',
    ogDescription: 'Service de transport privé premium entre Genève, Lyon et les stations de ski alpines. Excellence, ponctualité et confort depuis 2018.',
    ogImage: '/og-image.jpg',
    schema: {
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'WebSite',
          '@id': `${siteUrl}/#website`,
          url: siteUrl,
          name: 'Voyage Elite',
          description: 'Transport privé premium vers les stations de ski alpines',
          publisher: {
            '@id': `${siteUrl}/#organization`
          },
          potentialAction: {
            '@type': 'SearchAction',
            target: {
              '@type': 'EntryPoint',
              urlTemplate: `${siteUrl}/?s={search_term_string}`
            },
            'query-input': 'required name=search_term_string'
          },
          inLanguage: 'fr-FR'
        },
        {
          '@type': 'WebPage',
          '@id': `${siteUrl}/#webpage`,
          url: siteUrl,
          name: 'Voyage Elite - Transport Privé Premium Genève Lyon Stations Ski Alpes',
          description: 'Transport privé premium vers les stations de ski alpines depuis Genève et Lyon',
          inLanguage: 'fr-FR',
          isPartOf: {
            '@id': `${siteUrl}/#website`
          }
        },
        generateOrganizationSchema(),
        generateServiceSchema()
      ]
    }
  });

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <HeroSection />
      <ServicesSection />
      <DestinationsSection />
      <VehiclesSection />
      <ReservationModule />
      <TestimonialsSection />
      <FAQSection />
      <CTASection />
      <Footer />
    </div>
  );
}
